import { combineReducers } from '@reduxjs/toolkit';
import createCustomerReducer from './create/createSlice';
import customerListReducer from './list/listSlice';
import deleteCustomerReducer from './delete/deleteSlice';
import viewCustomerReducer from './view/viewSlice';

const customerSlice = combineReducers({
    create: createCustomerReducer,
    list: customerListReducer,
    delete: deleteCustomerReducer,
    view: viewCustomerReducer,
});

export default customerSlice;
